import React, { useState, useEffect } from 'react';
import Rating from '@material-ui/lab/Rating';
import { useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { firestore } from '../../../configs/environments/firebase/firebaseApp';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';

import Snackbar from '../../../components/Snackbar';
import { isMobile } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import ModalOpinion from './ModalOpinion';
import axios from 'axios';
import './CardValoration.scss';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 464,
    height: 392,
    borderRadius: 4,
    padding: '24px 28px 32px 28px',
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
  },
  root: {
    width: 200,
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
  infoWrapper: {
    padding: '32px 38px 0',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  name: {
    fontSize: 20,
    color: '#10587f',
    textAlign: 'center',
    marginBottom: 16,
  },
  rating: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 55,
  },
  starIcons: {
    fontSize: '2.5rem',
    color: '#ffc200',
  },
  emptyStar: {
    color: '#c1c1c1',
  },
  modalIcon: {
    fontSize: 32,
    padding: '0 8px',
  },
  cardIcon: {
    padding: '0 4px',
  },
  buttonsContainer: {
    display: 'flex',
    flexFlow: 'column',
    paddingTop: 40,
  },
  notNow: {
    background: 'unset',
    border: 0,
    fontSize: 14,
    fontWeight: 'bold',
    color: '#10587f',
    cursor: 'pointer',
    outline: 'unset',
  },
}));

const labels = {
  0.5: 'Muy malo',
  1: 'Muy malo+',
  1.5: 'Malo',
  2: 'Malo+',
  2.5: 'Bien',
  3: 'Bien+',
  3.5: 'Bueno',
  4: 'Bueno+',
  4.5: 'Excelente',
  5: 'Excelente+',
};

const CardValoration = ({ authClient, client, opinions, rate, history, visibleOpinions, showLoading, hideLoading }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  //const [loadingFormData, setLoadingFormData] = useState(false);

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const onPreview = useRouteMatch('/preview');
  const clientLogged = client && client.role === 'cliente';
  const lawyerLogged =
    client && (client.role === 'lawyer' || client.role === 'lawFirm');

  const handleOpen = () => {
    if (clientLogged) {
      setOpen(true);
    } else if (lawyerLogged || onPreview) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const formValues = {
    opinion: '',
    rating: 0.5,
  };

  useEffect(() => {
    authClient && authClient.uid && process_opinion(authClient.uid)
  }, [])

  const handleSubmit = (
    values,
    { setSubmitting, setFieldError, setFieldValue }
  ) => {

    showLoading();
    //setLoadingFormData(true);
    setSubmitting(false);
    let uid = authClient && authClient.role === "lawyer" && authClient.idLawFirm && authClient.idLawFirm !== undefined ? authClient.idLawFirm : 'no-uid' ;
    let clientMes = client.uid ? client.uid : '';

    let data = {
      clientUid: client.uid,
      lawyerUid: authClient.uid,
      role: authClient.role,
      opinion: values.opinion,
      rating: values.rating === 0 ? 0.5 : values.rating,
      type: 'Opinion',
      messageNotification: {
        title: client.displayName ? client.displayName : (`${client.name} ${client.lastName} `) ,
        text: 'Ha dejado una opinión de tus servicios.',
        instruction:
          'Para ver la opinión, da click en la notificacion de tu perfil.',
      },
      typeAnalitics: 'formOpinion',
      idLawFirm: uid
    };

    // Pasar la url , la data y  el header(tipo de contenido = json)
    axios
      .post(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/create/create_data`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*"
          },
        }
      )
      .then((res) => {
        let rateNew;
        //console.log('0rate', rate);
        //console.log('0values.rating', values.rating);
        if (rate === 0 || values.rating === 0) {
          //console.log('rate', rate);
          //console.log('values.rating', values.rating);

          rateNew = parseFloat(rate) + parseFloat(values.rating);
        } else {
          //console.log('2rate', rate);
          //console.log('2values.rating', values.rating);
          rateNew = (parseFloat(rate) + parseFloat(values.rating)) / 2;
        }
        //console.log('rateNew', rateNew);
        let totalRate = Number(rateNew).toFixed(1);
        //console.log('totalRate', totalRate);
        let num = isNaN(totalRate) ? values.rating : totalRate;

        firestore
          .collection('lawyerUsers')
          .doc(authClient.uid) //.set({ lawyers: [{ ...values, imgProfile }] }, { merge: true })
          .set(
            {
              analytics: {
                opinion: {
                  qualification: totalRate,
                  counts: opinions.length + 1,
                },
              },
            },
            { merge: true }
          )
          .then((res) => {
            handleClose();
            hideLoading();
            //setLoadingFormData(false);
            setFeedbackMessage({
              open: true,
              message: 'Se ha enviado la opinion con éxito',
              variant: 'success',
            });
             
            window.location.reload(); 
          });
      });
  };

  function process_opinion(uid) {
    let wholeData = []
    firestore.collection("opinions").doc(uid).collection('opinion').get()
      .then(querySnapshot => {
        console.log('querySnapshot', querySnapshot);
        querySnapshot.forEach(function(doc) {          
          wholeData.push(doc.data())
        });        
      })
      .catch(error => {})
  }

  const qualification =
    authClient.analytics &&
    Number(authClient.analytics.opinion.qualification);

  return (
    <>

      <section className="cardValora">
        <header className="cardValora_header">
          <p className="cardValora_title">Valoración</p>
        </header>
        <div className="cardValora_cali">
          <p
            className={
              authClient.analytics &&
              authClient.analytics.opinion.qualification > 0
                ? 'cardValora_cali_set'
                : 'cardValora_cali_unset'
            }
          >
            {visibleOpinions && visibleOpinions.length === 0 ?
              '0/5' :
              `${qualification}/5`
            }
          </p>

          <div className="cardValora_stars">
            {authClient && authClient ? (
              <Rating
                value={
                  authClient.analytics !== undefined
                    ? authClient.analytics.opinion.qualification
                    : 0
                }
                precision={0.25}
                classes={{
                  root: classes.starIcons,
                  iconEmpty: classes.emptyStar,
                  icon: classes.cardIcon,
                }}
                readOnly
              />
            ) : (
              ''
            )}
          </div>
        </div>
        <footer
          onClick={handleOpen}
          className={
            (authClient.analytics &&
            authClient.analytics.opinion.counts > 0) ||
            (visibleOpinions && visibleOpinions.length > 0)
              ? 'cardValora_footer_withOpinions'
              : 'cardValora_footer_withoutOpinions'
          }
          style={onPreview || lawyerLogged ? { cursor: 'not-allowed' } : null}
        >
          <p>
            {visibleOpinions &&
            visibleOpinions.length > 0
              ? visibleOpinions.length === 1
                ? '1 Opinión'
                : `${visibleOpinions.length} Opiniones`
              : 'Sin opiniones'}
          </p>
        </footer>
      </section>
      <ModalOpinion
        open={open}
        handleClose={handleClose}
        authClient={authClient}
        clientLogged={clientLogged}
        formValues={formValues}
        handleSubmit={handleSubmit}
      />
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '8px' : '80px'}
      />
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(null, mapDispatchToProps)(withRouter(CardValoration));
